import React from "react";
import { Form, Input, Button, Card, message, Typography } from "antd";
import { Mail, Lock, Phone, Building, User } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import useUserStore from "../store/userStore";

const { Title, Text } = Typography;

const Register = () => {
  const navigate = useNavigate();
  const { register, isLoading, error, clearError } = useUserStore();
  const [form] = Form.useForm();

  // 组件加载时清除错误状态
  React.useEffect(() => {
    clearError();
  }, [clearError]);

  const onFinish = async (values) => {
    const result = await register(values);
    if (result.success) {
      message.success("注册成功");
      navigate("/");
    } else {
      message.error(result.error);
    }
  };

  return (
    <div
      key="register"
      className="min-h-screen flex items-center justify-center bg-gray-50 p-4"
    >
      <Card className="w-full max-w-md shadow-lg" bordered={false}>
        <div className="text-center mb-6">
          <Title level={3} className="mb-2">
            注册账号
          </Title>
          <Text type="secondary">加入我们，体验新一代人工智能技术</Text>
        </div>

        <Form form={form} name="register" layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="email"
            label="邮箱"
            rules={[
              { required: true, message: "请输入您的邮箱" },
              { type: "email", message: "请输入有效的邮箱地址" },
            ]}
          >
            <Input
              prefix={<Mail className="text-gray-400" size={16} />}
              placeholder="请输入邮箱"
              className="h-11"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="密码"
            rules={[
              { required: true, message: "请输入密码" },
              { min: 8, message: "密码长度不能少于8位" },
            ]}
          >
            <Input.Password
              prefix={<Lock className="text-gray-400" size={16} />}
              placeholder="请输入密码"
              className="h-11"
              visibilityToggle
            />
          </Form.Item>

          <Form.Item
            name="confirm_password"
            label="确认密码"
            dependencies={["password"]}
            rules={[
              { required: true, message: "请再次输入密码" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("两次输入的密码不一致"));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<Lock className="text-gray-400" size={16} />}
              placeholder="请再次输入密码"
              className="h-11"
              visibilityToggle
            />
          </Form.Item>

          <Form.Item
            name="phone"
            label="手机号"
            rules={[
              { required: true, message: "请输入您的手机号" },
              { pattern: /^1[3-9]\d{9}$/, message: "请输入有效的手机号" },
            ]}
          >
            <Input
              prefix={<Phone className="text-gray-400" size={16} />}
              placeholder="请输入手机号"
              className="h-11"
            />
          </Form.Item>

          <Form.Item
            name="company_name"
            label="企业名称"
            rules={[
              { required: true, message: "请输入企业名称" },
              { min: 2, message: "企业名称长度不能少于2个字符" },
            ]}
          >
            <Input
              prefix={<Building className="text-gray-400" size={16} />}
              placeholder="请输入企业名称"
              className="h-11"
            />
          </Form.Item>

          <Form.Item className="mb-6">
            <Button
              type="primary"
              htmlType="submit"
              className="w-full h-11 text-base"
              loading={isLoading}
              size="large"
            >
              注册
            </Button>
          </Form.Item>

          <div className="text-center">
            <Text type="secondary">
              已有账号？
              <Link
                to="/login"
                className="text-blue-600 hover:text-blue-800 font-medium"
              >
                立即登录
              </Link>
            </Text>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Register;
